import styled from 'styled-components'
import { TitleValueBlockV2 } from 'Layout'
import { BREAK_POINT_MD } from '@CSSVars/variables'


export const _BuildingDetails = styled.div`
  display: flex;
  flex-direction: column;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
  }
`

export const _DetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: start;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column;
    align-items: start;
  }
`


export const _TitleValueBlock = styled(TitleValueBlockV2)`
  width: 25%;
  padding-right: 10px;
  div:first-child {
    font-weight: 500;
  }
  div:nth-child(2) {
    div{
      display: flex;
      flex-direction: column;
      span {
        line-height: 22px;
      }
    }
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-bottom: 12px;
    width: 100%;
  }
`
